const administracionDePermisos = {
    GuardarPermisosDePagina: 'SICPO/Intranet/Administracion/Permisos/GuardarPermisosDePagina',
    GuardarPermisosDeSeccion: 'SICPO/Intranet/Administracion/Permisos/GuardarPermisosDeSeccion',
    ObtenerPermisosDeSeccion: 'SICPO/Intranet/Administracion/Permisos/ObtenerPermisosDeSeccion',
    ObtenerUsuarios: 'SICPO/Intranet/Administracion/Permisos/ObtenerUsuarios',
    ObtenerSecciones: 'SICPO/Intranet/Administracion/Permisos/ObtenerSecciones',
    GuardarSeccionesUsuarios: 'SICPO/Intranet/Administracion/Permisos/GuardarSeccionesUsuarios',
    GuardarPermisosAPlataformaIntranet: 'SICPO/Intranet/Administracion/Permisos/GuardarPermisosAPlataformaIntranet',
    ObtenerSeccionesDeUsuario: 'SICPO/Intranet/Administracion/Permisos/ObtenerSeccionesDeUsuario'
}

export default administracionDePermisos;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/intranet/administracionDePermisos/administracionDePermisos.js
// module id = null
// module chunks = 